import StoreContainer from 'store/container';

const getDataExtractionDefinitions = () => {
  const { dataExtractionDefinitions } = StoreContainer.store.getState();

  return dataExtractionDefinitions;
};

export default {
  getDataExtractionDefinitions,
};
